  
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider';

  import { fetchPayruns, updatePayrun, emailPayslip } from './PayrunService';
  // Email payslip handler
  async function handleEmailPayslip(item, token) {
    try {
      await emailPayslip(item, token);
      alert('Payslip emailed successfully.');
    } catch (error) {
      console.error('Email payslip failed:', error);
      alert('Failed to email payslip.');
    }
  }
export default function PayrunListPage(props) {
  // Email selected handler (inside component)
  async function handleEmailSelected(items, token) {
    if (!items.length) {
      alert('No payruns selected.');
      return;
    }
    for (const item of items) {
      try {
        await handleEmailPayslip(item, token);
      } catch (err) {
        console.error('Failed to email payrun', item.id, err);
      }
    }
    alert('Selected payslips emailed!');
    window.location.reload();
  }
  const [payruns, setPayruns] = useState([]);
  const [companyId] = useState('company-123'); // or pull from user context
  const [dateFrom] = useState('2025-06-01');
  const [dateTo] = useState('2025-06-30');
  const [selected, setSelected] = useState({}); // { [dateRange]: Set of selected ids }
  const navigate = useNavigate();
  const authContext = useAuth();
  // Paid handler for a single payslip
  async function handleMarkPaid(item, token) {
    try {
      await updatePayrun({ ...item, paid: 'Y' }, token);
      alert('Marked as paid.');
      window.location.reload();
    } catch (error) {
      console.error('Failed to mark as paid', error);
      alert('Failed to mark as paid.');
    }
  }

  // Helper to format date as dd-mm-yyyy
  function formatDateDMY(date) {
    if (!date) return '';
    const d = dayjs(date);
    if (!d.isValid()) return date;
    return d.format('DD-MM-YYYY');
  }
  // Finalise and email handler
  async function handleFinaliseAndEmailSelected(items, token) {
    if (!items.length) {
      alert('No payruns selected.');
      return;
    }
    if (!window.confirm('Are you sure you want to finalise and email the selected payslips?')) return;
    for (const item of items) {
      try {
        // Finalise
        await updatePayrun({ ...item, status: 'finalised' }, token);
        // Email
        await emailPayslip({ ...item, status: 'finalised' }, token);
      } catch (err) {
        console.error('Failed to finalise/email payrun', item.id, err);
      }
    }
    alert('Selected payslips finalised and emailed!');
    window.location.reload();
  }
  // Batch finalise handler for selected items
  async function batchFinaliseSelected(items, token) {
    if (!items.length) {
      alert('No payruns selected.');
      return;
    }
    if (!window.confirm('Are you sure you want to finalise the selected payruns?')) return;
    for (const item of items) {
      try {
        await updatePayrun({ ...item, status: 'finalised' }, token);
      } catch (err) {
        console.error('Failed to finalise payrun', item.id, err);
      }
    }
    alert('Selected payruns finalised!');
    window.location.reload();
  }

  // Checkbox handlers
  const handleSelect = (dateRange, id) => {
    setSelected(prev => {
      const group = new Set(prev[dateRange] || []);
      if (group.has(id)) {
        group.delete(id);
      } else {
        group.add(id);
      }
      return { ...prev, [dateRange]: group };
    });
  };

  const handleSelectAll = (dateRange, items) => {
    setSelected(prev => {
      const allIds = items.map(i => i.id);
      const group = new Set(prev[dateRange] || []);
      if (group.size === allIds.length) {
        // Unselect all
        return { ...prev, [dateRange]: new Set() };
      } else {
        // Select all
        return { ...prev, [dateRange]: new Set(allIds) };
      }
    });
  };

  useEffect(() => {
    fetchPayruns(props.additionalUserInfo.companyId, dateFrom, dateTo, authContext.token).then(setPayruns);
  }, [companyId, dateFrom, dateTo]);

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">Payruns</h1>
      <div>
        <h2>Grouped Payrun Data</h2>
        {Object.entries(payruns).map(([dateRange, items]) => {
          const groupSelected = selected[dateRange] || new Set();
          const allSelected = groupSelected.size === items.length && items.length > 0;
          // Check if all items in this group are finalised
          const allFinalised = items.length > 0 && items.every(i => i.status === 'finalised');
          // Format dateRange if it matches fromDate-toDate
          let formattedDateRange = dateRange;
          if (typeof dateRange === 'string' && dateRange.includes('-')) {
            const match = dateRange.match(/^(\d{4}-\d{2}-\d{2})\s*-\s*(\d{4}-\d{2}-\d{2})$/);
            if (match) {
              const from = match[1];
              const to = match[2];
              const formattedFrom = from ? formatDateDMY(from) : from;
              const formattedTo = to ? formatDateDMY(to) : to;
              formattedDateRange = `${formattedFrom} - ${formattedTo}`;
            }
          }
          return (
            <div key={dateRange} style={{ marginBottom: '2rem', position: 'relative' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>{formattedDateRange}</h3>
                <div>
                  {!allFinalised && (
                    <>
                      <button
                        style={{ background: '#f59e42', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', cursor: 'pointer', marginRight: 8 }}
                        onClick={() => batchFinaliseSelected(items.filter(i => groupSelected.has(i.id)), (props.authToken || (typeof useAuth === 'function' ? authContext.token : undefined)))}
                      >
                        Finalise Selected
                      </button>
                      <button
                        style={{ background: '#388e3c', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', cursor: 'pointer', marginRight: 8 }}
                        onClick={() => handleFinaliseAndEmailSelected(items.filter(i => groupSelected.has(i.id)), (props.authToken || (typeof useAuth === 'function' ? authContext.token : undefined)))}
                      >
                        Finalise and email selected
                      </button>
                    </>
                  )}
                  <button
                    style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', cursor: 'pointer', marginRight: 8 }}
                    onClick={() => handleEmailSelected(items.filter(i => groupSelected.has(i.id)), (props.authToken || (typeof useAuth === 'function' ? authContext.token : undefined)))}
                  >
                    Email selected
                  </button>
                  <label style={{ marginLeft: 8 }}>
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={() => handleSelectAll(dateRange, items)}
                    />
                    Select All
                  </label>
                </div>
              </div>
              <table border="1" cellPadding="8" cellSpacing="0" width="100%">
                <thead>
                  <tr>
                    {!allFinalised && <th></th>}
                    <th>Staff Name</th>
                    <th>Email</th>
                    <th>Company</th>
                    <th>Date</th>
                    <th>Base Rate</th>
                    <th>Normal Hours</th>
                    <th>Total Pay</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map(item => (
                    <tr key={item.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={groupSelected.has(item.id)}
                          onChange={() => handleSelect(dateRange, item.id)}
                        />
                        {item.staffName}
                      </td>
                      
                      <td>{item.staffEmail}</td>
                      <td>{item.companyName}</td>
                      <td>{formatDateDMY(item.date)}</td>
                      <td>${item.basePayRate}</td>
                      <td>{item.normalHours}</td>
                      <td>${item.totalPay}</td>
                      <td>
                        <button
                          className="bg-blue-500 text-white px-3 py-1 rounded"
                          onClick={() => navigate(`/payrun/${item.id}`)}
                        >
                          View
                        </button>
                        {item.status === 'finalised' && (
                          <button
                            style={{ marginLeft: 8, background: '#4caf50', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 12px', cursor: 'pointer' }}
                            onClick={() => handleEmailPayslip(item, (props.authToken || (typeof useAuth === 'function' ? authContext.token : undefined)))}
                          >
                            Email payslip
                          </button>
                        )}
                        {item.paid !== 'Y' && (
                          <button
                            style={{ marginLeft: 8, background: '#f57c00', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 12px', cursor: 'pointer' }}
                            onClick={() => handleMarkPaid(item, (props.authToken || (typeof useAuth === 'function' ? authContext.token : undefined)))}
                          >
                            Paid
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    </div>
  );
}
